<div class="wrap uk-margin-bottom">

    <!-- <div class="uk-margin-bottom">
        <span class="main-title"><span class="bold">Alertes</span> pour le <span humanDateFormat="{{ today }}"
                shortened="true"></span></span>
    </div> -->

    <div class="uk-width-1-1" style="margin-left: -20px;" uk-grid>
        <div class="uk-margin uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block" style="margin-top: 20px;">
                <button class="uk-button round-button uk-display-inline-block"
                    [class.round-button-toggle]="filter === 0" (click)="changeFilter(0)">
                    Tout
                </button>
            </div>
        </div>
        <div class="uk-margin uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block"
                    [class.round-button-toggle]="filter === 1" (click)="changeFilter(1)">
                    Stations
                </button>
            </div>
        </div>
        <div class="uk-margin uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block"
                    [class.round-button-toggle]="filter === 2" (click)="changeFilter(2)">
                    Alertes
                </button>
            </div>
        </div>
        <div class="uk-margin uk-display-inline-block research-form-controls" style="width: 420px;">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <span *ngIf="vehicleLoading === false" class="uk-form-icon uk-form-icon-flip">
                    <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                </span>
                <span *ngIf="vehicleLoading === true" class="uk-form-icon uk-form-icon-flip">
                    <div style="width:24px; height: 24px;" uk-spinner></div>
                </span>
                <input class="search-bar" type="text" [(ngModel)]="vehicleSearch"
                    (ngModelChange)="updateVehicleOptionList($event)" (focus)="toggleSuggestions(true)"
                    (focusout)="toggleSuggestions(false)" placeholder="Localiser un véhicule"
                    style="padding-right: inherit !important;">
                <div [class.display-none]="vehicleDisplay === false" class="suggestions">
                    <div [class.display-none]="vehicleOptions.length === 0" class="arrow"></div>
                    <div [class.display-none]="vehicleNoResult === false">
                        Pas de résultats
                    </div>
                    <div [class.display-none]="vehicleNoResult === true" *ngFor="let option of vehicleOptions"
                        (click)="setVehicleSearch(option)">
                        {{ option.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div *ngIf="loading === true">
    <div uk-spinner class="uk-position-center"></div>
</div>

<div>
    <div style="width:100%; height: calc(100vh - 350px);" id="map"></div>
</div>